import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  ITransactionsPayload,
  ITransactionsResponse
} from '@/interfaces/transactions'
export const fetchItems = async (
  payload: ITransactionsPayload
): Promise<ITransactionsResponse> => {
  let params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('sorter', { direction: 'desc', field: 'created_at' })
  )
  if (payload.filter.type_id !== 100500) {
    params = Object.assign(
      params,
      nestedQueryFormatter('filter', payload.filter, false)
    )
  } else {
    params = Object.assign(
      params,
      nestedQueryFormatter(
        'filter',
        {
          created_at_gteq: payload.filter.created_at_gteq,
          created_at_lteq: payload.filter.created_at_lteq
        },
        false
      )
    )
  }
  const response = await apiClient.get<ITransactionsResponse>('/transactions', {
    params
  })
  return response.data
}
